import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../services/api';

export const fetchHistoryItems = createAsyncThunk('history/fetchHistoryItems', async () => {
  try {
    const response = await api.get('/history');
    if (Array.isArray(response.data)) {
      const sortedData = response.data.sort((a, b) => {
        if (a.year === b.year) {
          return a.order - b.order;
        }
        return a.year - b.year;
      });

      // Asynchronously preload all history images
      sortedData.forEach(item => {
        if (item.imageUrl) {
          const img = new Image();
          img.src = item.imageUrl;
        }
      });

      return sortedData;
    }
    return [];
  }
  catch (error) {
    return []
  }
}
);

const historySlice = createSlice({
  name: 'history',
  initialState: {
    historyData: {
      item: [],
      status: 'idle',
      error: null,
    }
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistoryItems.pending, (state) => {
        if (!state.historyData) state.historyData = {};
        state.historyData.status = 'loading';
      })
      .addCase(fetchHistoryItems.fulfilled, (state, action) => {
        if (!state.historyData) state.historyData = {};
        state.historyData.status = 'succeeded';
        state.historyData.item = action.payload;
      })
      .addCase(fetchHistoryItems.rejected, (state, action) => {
        if (!state.historyData) state.historyData = {};
        state.historyData.status = 'failed';
        state.historyData.error = action.error.message;
      });
  },
});

export const selectHistoryData = (state) => state.history.historyData;

export default historySlice.reducer;
